import { ActionBar, IconButtonRefresh, Left, Right } from "../../../../core/components"
import { DashboardActionBarFilters } from "./DashboardActionBarFilters"

interface DashboardActionBarProps {
    isLoading?: boolean
    refreshCallback: () => void
}

export const DashboardActionBar: React.FC<DashboardActionBarProps> = (props) => {
    return (
        <ActionBar className="dashboard-action-bar border-light">
            <Left>
                <DashboardActionBarFilters dropdownThreshold={1000} />
            </Left>
            <Right>
                <IconButtonRefresh onClick={props.refreshCallback} spin={props.isLoading} />
            </Right>
        </ActionBar>
    )
}
